/**
 * @generated SignedSource<<3bb771c15aac23acb03e8901e5679d3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AclInputEntry = {
  actions: ReadonlyArray<string>;
  role: string;
};
export type PlaylistAccessAclMutation$variables = {
  acl: ReadonlyArray<AclInputEntry>;
  id: string;
};
export type PlaylistAccessAclMutation$data = {
  readonly updatePlaylist: {
    readonly acl: ReadonlyArray<{
      readonly actions: ReadonlyArray<string>;
      readonly info: {
        readonly implies: ReadonlyArray<string> | null | undefined;
        readonly label: { default: string } & Record<string, string | undefined>;
        readonly large: boolean;
      } | null | undefined;
      readonly role: string;
    }>;
  };
};
export type PlaylistAccessAclMutation = {
  response: PlaylistAccessAclMutation$data;
  variables: PlaylistAccessAclMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "acl",
    "variableName": "acl"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AclItem",
  "kind": "LinkedField",
  "name": "acl",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "implies",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "large",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaylistAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AuthorizedPlaylist",
        "kind": "LinkedField",
        "name": "updatePlaylist",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PlaylistAccessAclMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AuthorizedPlaylist",
        "kind": "LinkedField",
        "name": "updatePlaylist",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ac62fb8604e12cce59aa3f1dd088025",
    "id": null,
    "metadata": {},
    "name": "PlaylistAccessAclMutation",
    "operationKind": "mutation",
    "text": "mutation PlaylistAccessAclMutation(\n  $id: ID!\n  $acl: [AclInputEntry!]!\n) {\n  updatePlaylist(id: $id, acl: $acl) {\n    acl {\n      role\n      actions\n      info {\n        label\n        implies\n        large\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5425b863736ef87878d381f30af7a985";

export default node;
